export default __webpack_public_path__ + "static/media/plan-enterprise.8d334b89.svg";